module.exports = __webpack_public_path__ + "static/media/spanish-alphabet-list.7cd07292.jpg";